import { component } from "picoapp";

export default component((node, ctx) => {
  node.addEventListener("submit", handleSubmit);
  const individualControl = node.querySelector(".js-individual-control");
  const stateSelector = node.querySelector('[name="states"]');
  const countrySelector = node.querySelector('[name="country"]');

  countrySelector.addEventListener("change", (e) => {
    const country = countrySelector.value;
    const stateDisabled = !(country === "United States");
    stateSelector.disabled = stateDisabled;
    if (stateDisabled) {
      stateSelector.value = "Not Applicable";
    } else {
      stateSelector.value = "";
    }
  });

  individualControl.addEventListener("change", (e) => {
    const val = e.target.value;
    const el = node.querySelector(".privacy-form-authorized-agent");
    const isHidden = val === "individual";
    el.setAttribute("aria-hidden", isHidden);
  });

  function handleSubmit(event) {
    event.preventDefault();
    const data = new FormData(event.target);
    fetch("https://formspree.io/f/xoqbnryk", {
      method: "post",
      body: data,
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          const wrapper = document.querySelector(".js-privacy-form-wrapper");
          const successMsg = document.querySelector(".js-privacy-form-success");
          wrapper.style.display = "none";
          successMsg.style.display = "";
          successMsg.scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "center",
          });
          event.target.reset();
        } else {
          document.querySelector(".js-privacy-error").innerHTML =
            "There was an error submitting your form. Please try again.";
        }
      })
      .catch((e) => {
        document.querySelector(".js-privacy-error").innerHTML =
          "There was an error submitting your form. Please try again.";
      });
  }

  return (node) => {
    node.removeEventListener("submit", handleSubmit);
  };
});
